import React from 'react';
import { useReadOnboardingQueryString } from './onboardingQueryString';
import {
  SUBJECT_ORG_ONBOARDING,
  TUTORIAL_NAME_POST,
  TUTORIAL_NAME_SEARCH,
  TUTORIAL_NAME_TOPIC,
} from '../constants/onboarding';
import OrganizationOnboardingContainer from './organization/OrganizationOnboardingContainer';
import PostTutorial from './tutorial/PostTutorial';
import SearchTutorial from './tutorial/SearchTutorial';
import TopicTutorial from './tutorial/TopicTutorial';
import TutorialFixedContainer from './tutorial/TutorialFixedContainer';
import useOnboardingData from './useOnboardingData';
import useLegacyIsLoggedIn from '../account/useIsLoggedIn';
import useAppSelector from '../app/redux/useAppSelector';

const TUTORIAL_VIEW = {
  [TUTORIAL_NAME_POST]: PostTutorial,
  [TUTORIAL_NAME_SEARCH]: SearchTutorial,
  [TUTORIAL_NAME_TOPIC]: TopicTutorial,
} as const;

const BaseOnboardingContainer = () => {
  useReadOnboardingQueryString();

  const orgOnboardingData = useOnboardingData(SUBJECT_ORG_ONBOARDING);
  const { onboarding } = orgOnboardingData;

  const onboardingElement = onboarding &&
    !onboarding.completedAt &&
    !onboarding.skippedAt && (
      <OrganizationOnboardingContainer {...orgOnboardingData} />
    );

  const activeTutorial = useAppSelector(
    (state) => state.onboarding.activeTutorial,
  );

  const Tutorial = activeTutorial && TUTORIAL_VIEW[activeTutorial];

  return (
    <>
      {onboardingElement}
      {!!Tutorial && (
        <TutorialFixedContainer>
          <Tutorial />
        </TutorialFixedContainer>
      )}
    </>
  );
};

const OnboardingContainer = () => {
  const isLoggedIn = useLegacyIsLoggedIn();

  return isLoggedIn ? <BaseOnboardingContainer /> : null;
};

export default OnboardingContainer;
